import CreateOrderSuccess from "@/views/admin/order/CreateOrderSuccess";

export default {
  path: "orders/create-order/success",
  name: "CreateOrderSuccess",
  component: CreateOrderSuccess,
  meta: {
    requiresAuth: true
  }
};
